import Dropzone from 'dropzone';
import $menuify from '../components/menu.js';
import $pjaxify from '../components/pjax.js';
import $posterify from '../components/poster.js';
import $createFacebookShareLink from '../components/facebook-share.js';
import $overlayify from '../components/overlay.js';
import $formcontrollify from '../components/formcontrol.js';
import initMap from '../components/map/index.js';
import previewEvent from '../components/preview.js';
import autosize from 'autosize';
import '../components/wallfilter.js';
import '../components/postereditor.js';
import 'foundation/js/foundation/foundation.js';
import 'foundation/js/foundation/foundation.reveal.js';
import 'parsleyjs/dist/parsley.js';
import 'matchHeight/jquery.matchHeight.js';

window.ParsleyConfig = {
    errorsContainer: function(el) {
        var fieldcol = el.$element.closest('.form__fieldcol');
        fieldcol.find('.errorlist').remove();
        return fieldcol;
    }
};

window.ParsleyValidator.addValidator('conditionalrequired',
function (value, requirements) {
    if ($(requirements).length) {
        if (value === '') {
            return false;
        }
    }
    return true;
}, 32);

$.listen('parsley:field:error', function(fieldInstance){
    var arrErrorMsg = ParsleyUI.getErrorsMessages(fieldInstance);
    var errorMsg = arrErrorMsg.join(';');
    var fieldName = fieldInstance.$element.attr('name');
    console.log('Errors for field ' + fieldName + ': ' + errorMsg);
});

$(document).on('ready', function (){

    $menuify();
    $pjaxify();
    $formcontrollify();

    var $wallfilter = $('[data-js-wallfilter]');
    if($wallfilter.length > 0) {
        $wallfilter.wallFilter({
            pjax: {
                container: '#wall',
                fragment: '#wall'
            }
        }).wallFilter('log');
    }

    Dropzone.options.posteditorDropzone = false;
    $('[data-js-postereditor]').posterEditor({
        dropzone: {
            url: '/events/tile-images/',
        },
        api: {
            imgurl: '/events/tile-images/',
        }
    }).posterEditor('log');

    if($('#map').length) {
        initMap();
    }

    $('[data-js-matchheight="footnav"]').matchHeight();

    previewEvent($('#create-event-form'), $('#event-create-preview'));

}).on('ready pjax:end overlay:loaded loadmore:end', function () {
    $overlayify();
    $posterify();
	$createFacebookShareLink();
    autosize($('textarea'));
});

export default true;



// WEBPACK FOOTER //
// ./src/js/app/main/index.js